<template>
  <Row class="justify-end">
    <Button
      :title="lc.title"
      :label="lc.title"
      :disabled="isLoading"
      color="primary"
      iconSize="small"
      prependIcon="$media-image-filled"
      @click="$refs.uploadFaviconInput.$refs.input.click()"
    />
    <v-file-input
      class="d-none"
      ref="uploadFaviconInput"
      @change="createFavicon"
    />
  </Row>
</template>

<script>
import { computed, ref, unref } from 'vue'
import { Button, Row, useLocale, useNotification, useVueRouter } from '@locaweb/design-system-vue'
import { NOTIFICATION_DEFAULTS } from '@/consts'
import { useCreateFavicon } from '@/composables/api/useCreateFavicon'
import { fileEncode64 } from '@/composables/fileEncode64'

export default {
  name: 'UploadFavicon',
  components: {
    Row,
    Button
  },
  setup (_, { emit }) {
    const notify = useNotification()
    const { $route } = useVueRouter()
    const lc = useLocale('site.favicon.faviconCard.uploadFavicon')
    const { loading: isLoading, execute: executeCreate } = useCreateFavicon()

    const uploadFaviconInput = ref(null)
    const siteId = computed(() => $route.params.siteId)

    const onSuccess = () => {
      notify.show({ ...NOTIFICATION_DEFAULTS, message: lc.createSuccess, state: 'success' })
      emit('onSuccess')
    }

    const onError = (response) => {
      const errorMessage = response?.data?.errors || lc.createError
      notify.show({ ...NOTIFICATION_DEFAULTS, message: errorMessage, state: 'error' })
    }

    const createFavicon = async (faviconFile) => {
      const base64file = await fileEncode64(faviconFile)
      const favicon = {
        fileContent: base64file,
        filename: faviconFile.name,
        fileType: faviconFile.type
      }

      await executeCreate({
        id: unref(siteId),
        favicon,
        onSuccess,
        onError
      })
    }

    return { lc, isLoading, createFavicon, uploadFaviconInput }
  }
}
</script>
